module.exports = __webpack_public_path__ + "media/images/common/ico-rank-5-c41814b949df927e70537aaddfae17f1.svg";